// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"bb652992","368":"6fb17877"}[chunkId] + ".chunk.js";
};